module.exports = __webpack_public_path__ + "9fff117e84180f70cc876742d186b8a4.png";